<template>
	<div class="d-flex j-center">
		<div class="content-box">
			<div style="height: 50px;line-height: 50px;font-size: 12px;padding-left: 620px;">
				<span style="font-weight: 700;">企业介绍背景图</span>
				<span style="color: #888888;">(建议尺寸750x400,400KB为宜，支持JPG、PNG)</span>
			</div>
			<div class="d-flex jc-center">
				<div class="left-box">
					<div class="d-flex j-center a-center w-100" 
					style="flex-wrap: wrap;background: #FFFFFF;
					box-shadow: 0px 6px 16px 0px rgba(30, 105, 255, 0.17);border-radius: 4px;">
						<img style="width: 100%;height: 200px;" :src="tempBg" />
					</div>
					<div style="height: 50px;font-size: 13px;font-weight: 700;cursor: pointer;
					box-sizing: border-box;padding-bottom: 5px;" class="d-flex a-center">
						<div class="w-50" style="border-right: 1px solid #bbb;text-align: center;height: 13px;"
						:style="tabState?'color:#333333':'color:#bbbbbb'">
							企业动态
						</div>
						<div class="w-50" style="text-align: center;height: 13px;"
						:style="tabState?'color:#bbbbbb':'color:#333333'">
							企业发布
						</div>
					</div>
					<div class="img-box" style="background: #F5F5F5;box-sizing: border-box;padding: 0 12px;overflow-y: scroll;height: 475px;">
						<template v-if="!tabState">
							<div class="d-flex" v-for="(item,index) in megData" :key="index">
								<div class="d-flex a-center" style="flex: 1;padding: 10px;box-sizing: border-box;
								background: #FFFFFF;margin-top: 10px;border-radius: 5px;">
									<div style="width: 56px;height: 56px;">
										<img style="width: 56px;height: 56px;" :src="item.title_img" />
									</div>
									
									<div style="height: 56px;justify-content: space-between;margin-left: 10px;
									flex-direction: column;flex: 1;display: flex;">
										<div style="font-size: 13px;font-weight: 700;">{{user_info.company_name}}</div>
										<div style="font-size: 11px;color: #888;">
										{{item.province_name}}{{item.city_name}}{{item.district_name}}
										| {{item.goods_id==0?'全部商品代理':'部分商品代理'}} | {{item.work_type_name}}
										</div>
										<div style="font-size: 11px;color: #888;">
											{{item.contact_name}} | {{item.contact_tel}}
										</div>
									</div>
								</div>
							</div>
							<div v-if="megData.length==0" class="d-flex j-center" style="padding-top: 150px;">
								<img style="width: 150px!important;height: 150px;" src="../../assets/Home/zwsj@2x.png" />
							</div>
						</template>
						
						<div v-show="tabState" style="display: flex;flex-wrap: wrap; justify-content: space-between;">
							<div v-for="(item,index) in wzList" :key="index" @click="openVideo(item)"
							style="width: 170px;background: #FFFFFF;margin-top: 12px;display: inline-block;position: relative;">
								<img v-if="item.doc_type==0" style="width: 100%;height:96px;border-radius: 6px 6px 0 0;" :src="item.cover" />
								<video v-if="item.type==1" width="170" height="96px" style="border-radius: 6px 6px 0 0;" :src="item.cover"/>
								<div style="font-size: 14px;box-sizing: border-box;padding: 0 6px;overflow:hidden;height: 40px;
								text-overflow:ellipsis;display:-webkit-box; -webkit-box-orient:vertical;-webkit-line-clamp:2;">
									{{item.title}}
								</div>
								<div class="d-flex a-center" style="padding: 0 6px;margin-top: 6px;">
									<div style="width: 30px;height: 16px;border: 1px solid #BBBBBB;border-radius: 2px;
									font-size: 10px;color: #BBBBBB;display: flex;align-items: center;justify-content: center;">
										{{item.type==1?'文章':'视频'}} 
									</div>
									<div class="text-hide" style="font-size: 10px;color: #BBBBBB;margin-left: 6px;flex: 1;">{{user_info.company_name}}</div>
								</div>
								<div style="height: 6px;"></div>
								<div @click.stop="del_enterprise_dynamic(item)" 
								style="width: 60px;height: 24px;background: #000000;opacity: 0.6;border-radius: 0px 0px 0px 10px;cursor: pointer;
								position: absolute;top: 1px;right: 0;line-height: 24px;text-align: center;color: #FFFFFF;font-size: 12px;">
									删除
								</div>
							</div>
							<!-- <div v-for="(item,index) in wzList" :key="index" @click="openVideo(item)" style="cursor: pointer; height: 200px;margin-top: 25px;position: relative;">
									<div style="background: linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
									position: absolute;left: 0;right: 0;bottom: 0;top: 0;display: flex;align-items: flex-end;">
										<div class="d-flex a-center" style="padding: 12px 15px;">
											<div>
												<img style="border-radius: 50%;height: 40px;width: 40px;" :src="item.logo" />
											</div>
											<div style="margin-left: 10px;align-items: center;flex: 1;color: #FFFFFF;font-size: 14px;">
												{{item.title}}
											</div>
										</div>
									</div>
									<img v-if="item.type == 1"  style="width: 100%;height: 200px;cursor: pointer;" :src="item.cover" />
									<video v-else width="347" height="200" style="cursor: pointer;" :src="item.cover"></video>
									<div @click.stop="del_enterprise_dynamic(item)" style="width: 60px;height: 24px;background: #000000;opacity: 0.4;border-radius: 0px 0px 0px 10px;cursor: pointer;
									position: absolute;top: 1px;right: 0;line-height: 24px;text-align: center;color: #FFFFFF;font-size: 12px;">
										删除
									</div>
							</div> -->
						</div>
					</div>
					<div class="tabbar-box d-flex j-sb a-center">
						<div style="width: 37px;height: 37px;border-radius: 50%;box-sizing: border-box;">
							<img style="width: 100%;height: 100%;border-radius: 50%;" :src="user_info.logo_thumb" />
						</div>
						
						<div>
							<div style="text-align: center;height: 18px;">
								<img style="width: 18px;height: 18px;" src="../../assets/brand_fixtures/tabbar/qycpmr.png" />
							</div>
							<div style="font-size: 11px;color: #888888;text-align: center;">企业产品</div>
						</div>
						<div>
							<div style="text-align: center;height: 18px;">
								<img style="width: 18px;height: 18px;" src="../../assets/Home/dingdan@2x.png" />
							</div>
							<div style="font-size: 11px;color: #888888;text-align: center;">企业资料</div>
						</div>
						<div>
							<div style="text-align: center;height: 18px;">
								<img style="width: 18px;height: 18px;" src="../../assets/brand_fixtures/tabbar/qyhzmr.png" />
							</div>
							<div style="font-size: 11px;color: #888888;text-align: center;">企业合作</div>
						</div>
						
					</div>
				</div>
				<div class="right-box">
					<el-upload
					  class="avatar-uploader"
					  action="upload"
					  :show-file-list="false"
					  :on-change="getAdBg"
					  :http-request="()=>{}"
					  accept='.jpg,.png'>
					  <div class="d-flex j-center a-center w-100" 
					  style="flex-wrap: wrap;height: 85px;background: #FFFFFF;box-shadow: 0px 6px 16px 0px rgba(30, 105, 255, 0.17);
					  border-radius: 4px;">
						  <template v-if="adBg">
								<img style="width: 371px;height: 200px;border-radius: 3px 3px 0 0;" :src="adBg" />					  
						  </template>
						  <template v-else>
							  <img style="width: 371px;height: 200px;" src="../../assets/brand_fixtures/ggt.png" />
						  </template>
					  </div>
					</el-upload>
					<div style="height: 50px;font-size: 13px;font-weight: 700;cursor: pointer;
					box-sizing: border-box;padding-bottom: 5px;" class="d-flex a-center">
						<div @click="setTabstate(true)" class="w-50" style="border-right: 1px solid #bbb;text-align: center;height: 13px;"
						:style="tabState?'color:#333333':'color:#bbbbbb'">
							企业动态
						</div>
						<div @click="setTabstate(false)" class="w-50" style="text-align: center;height: 13px;"
						:style="tabState?'color:#bbbbbb':'color:#333333'">
							企业发布
						</div>
					</div>
					<!-- <div class="img-box" style="box-sizing: border-box;padding: 0 12px;overflow-y: scroll;height: 529px;">
						<div v-show="!tabState" style="display: flex;flex-wrap: wrap;width: 100%;overflow-x: hidden;" v-html="contents"></div>
						
					</div> -->
					<div v-show="!tabState" style="text-align: center;">
						<img style="width: 110px;height: 110px;margin-top: 100px;" src="../../assets/brand_fixtures/liuyan@2x.png" />
						<div style="width: 217px;font-size: 12px;color: #888;margin: 15px auto;">
							本页面不支持发布，点击“企业发布”模块发布企业招募信息
						</div>
						<div @click="$router.push('/release_info')" style="width: 128px;height: 32px;border: 1px solid #BBBBBB;border-radius: 4px;cursor: pointer;
						margin: 15px auto;font-size: 12px;color: #888888;display: flex;align-items: center;justify-content: center;">
							去发布 <img style="width: 11px;height: 11px;margin-left: 5px;" src="../../assets/order/jiantoujindian@2x.png" />
						</div>
					</div>
					
				</div>
				<div v-if="tabState == false"  class="button-box" style="opacity: 0;">
					<div style="text-align: center;">
						<img style="width: 20px;height: 20px;" src="../../assets/brand_fixtures/wenzi.png" />
						<div style="font-size: 11px;color: #666666;text-align: center;">添加内容</div>
					</div>					
				</div>
				<div v-if="tabState" class="button-box" style="height: 156px;flex-wrap: wrap;">
					<div @click="openCtshow()" style="text-align: center;width: 100%;">
						<img style="width: 20px;height: 20px;" src="../../assets/brand_fixtures/wenzi.png" />
						<div style="font-size: 11px;color: #666666;text-align: center;">文章</div>
					</div>
					<div @click="ishowVideo = true" style="text-align: center;">
						<img style="width: 20px;height: 20px;" src="../../assets/brand_fixtures/shipin.png" />
						<div style="font-size: 11px;color: #666666;text-align: center;">视频</div>
					</div>
				</div>
			</div>
			<div class="d-flex j-center a-center" style="margin-top: 30px;">
				<div @click="previewJs()" class="d-flex j-center a-center"
				style="width: 114px;height: 26px;background: #1E69FF;
				border-radius: 6px;color: #FFFFFF;cursor: pointer;font-size: 12px;">
					预览
				</div>
				<div @click="enterprise_introduction_release2" class="d-flex j-center a-center"
				style="width: 114px;height: 26px;background: #1E69FF;margin-left: 36px;
				border-radius: 6px;color: #FFFFFF;cursor: pointer;font-size: 12px;">
					发布
				</div>
			</div>
		</div>
		
		
		<el-dialog
		  :modal="true"
		  title="添加内容"
		  :visible.sync="centerDialogVisible"
		  width="830px"
		  center>
		  <vue-ueditor-wrap v-model="contents" :config="myConfig"></vue-ueditor-wrap>
		  <span slot="footer" class="dialog-footer">
		    <el-button size="mini" @click="centerDialogVisible = false">取 消</el-button>
		    <el-button size="mini" type="primary" @click="getContens()">确 定</el-button>
		  </span>
		</el-dialog>
		<el-dialog
		  :modal="true"
		  title="添加视频"
		  :visible.sync="ishowVideo"
		  width="830px"
		  center>
		  <div style="padding: 0 150px;">
			   <el-input v-model="videoTitle" maxlength="50" placeholder="请输入视频标题"></el-input>
		  </div>
		  <div style="height: 30px;"></div>
		  <div style="padding: 0 150px;">
			  <el-upload
			  :action="$apiurl + 'seller/enterprise_publicity_manage_api.php'"
			  :show-file-list="false" 
			  name="video"
			  :on-progress="onprogress"
			  :before-upload="beforeUpload"
			  :data="{'act':'upload_video','token':token,'user_id':user_id}"
			  :on-success="fileSuccess"
			  accept='.mp4,.avi,.wmv,.swf,.flv,.m4v'>
				  <div class="d-flex j-center a-center w-100" 
				  style="flex-wrap: wrap;background: #FFFFFF;
				  box-shadow: 0px 6px 16px 0px rgba(30, 105, 255, 0.17);border-radius: 4px;">
					<template v-if="videoBase64">
						<video controls style="width: 480px;height: 280px;" :src="videoBase64" />					  
					</template>
					<template v-else>
					  <img style="width: 480px;height: 280px;" src="../../assets/brand_fixtures/scsp.png" />
					</template>
				  </div>
			  </el-upload>
		  </div>
		  <div v-if="progress!=0" style="padding: 0 120px;text-align: center;">
			  <el-progress :percentage="progress" :format="format"></el-progress>
		  </div>
		  <span slot="footer" class="dialog-footer">
		    <el-button size="mini" @click="ishowVideo = false">取 消</el-button>
		    <el-button size="mini" type="primary" @click="enterprise_add_video()">确 定</el-button>
		  </span>
		</el-dialog>
		<el-dialog
		  :modal="true"
		  title="添加文章(请按照文章段落复制文字)"
		  :visible.sync="ctShow"
		  width="830px"
		  :show-close="false"
		  :close-on-press-escape="false"
		  :close-on-click-modal	="false"
		  center>
		  <template v-if="isSimple">
			  <div class="d-flex a-center">
				  <div style="width: 100%;flex-wrap: wrap;" class="d-flex j-center">
					  <div @click="isSimple=!isSimple" style="text-align: center;cursor: pointer;color: #226CFF;width: 100%;height: 50px;">
					  	简易模式
					  </div>
					  <el-input style="width: 259px;" size="small" v-model="wzTitle" maxlength="50" placeholder="请输入文章标题"></el-input>
				  </div>
				  <div style="width: 100%;margin: 10px 0;" class="d-flex j-center">
						<el-upload
						  class="avatar-uploader"
						  action="upload"
						  :show-file-list="false"
						  :on-change="getImg"
						  :http-request="()=>{}"
						  accept='.png,.jpg,.jpeg'>
						  <div class="d-flex j-center a-center w-100" 
						  style="flex-wrap: wrap;background: #FFFFFF;border: 1px solid #d0d0d0;border-radius: 4px;">
							  <template v-if="cover">
									<img style="width: 259px;height: 135px;" :src="cover" />					  
							  </template>
							  <template v-else>
								  <div style="width: 259px;height: 135px;line-height: 135px;">请添加封面背景</div>
							  </template>
						  </div>
						</el-upload>
				  </div>  
			  </div>
			  <vue-ueditor-wrap v-model="wzContents" :config="myConfig"></vue-ueditor-wrap>
		  </template>
		  <template v-else>
			  <div class="d-flex j-center">
				<div>
					<div @click="isSimple=!isSimple" style="text-align: center;cursor: pointer;color: #226CFF;width: 100%;height: 50px;">
						编辑器模式
					</div>
					<div style="width: 100%;" class="d-flex j-center">
					  <el-input style="width: 259px;" size="small" v-model="wzTitle" maxlength="50" placeholder="请输入文章标题"></el-input>
					</div>
				  <div style="width: 100%;margin: 10px 0;" class="d-flex j-center">
						<el-upload
						  class="avatar-uploader"
						  action="upload"
						  :show-file-list="false"
						  :on-change="getImg"
						  :http-request="()=>{}"
						  accept='.png,.jpg,.jpeg'>
						  <div class="d-flex j-center a-center w-100" 
						  style="flex-wrap: wrap;background: #FFFFFF;border: 1px solid #d0d0d0;border-radius: 4px;">
							  <template v-if="cover">
									<img style="width: 259px;height: 135px;" :src="cover" />					  
							  </template>
							  <template v-else>
								  <div style="width: 259px;height: 135px;line-height: 135px;">请添加封面背景</div>
							  </template>
						  </div>
						</el-upload>
				  </div>  
				</div>
				<div class="brand-home" style="margin-left: 30px;">
				<div style="width: 365px;height: 660px;border: 1px solid #979797;border-radius: 6px;overflow: hidden;">
					<div style="width: 100%;height: 48px;background: #f5f5f5;" class="d-flex">
						<div @click="txtShow=true" style="cursor: pointer;width: 20%;flex-wrap: wrap;text-align: center;" class="d-flex j-center">
							<img style="width: 18px;height: 18px;margin-top: 8px;" src="../../assets/brand_fixtures/wenzi.png" />
							<div style="font-size: 10px;color: #666666;width: 100%;text-align: center;margin-bottom: 8px;transform: scale(0.9);">文字</div>
						</div>
						<el-upload style="cursor: pointer;width: 20%;flex-wrap: wrap;text-align: center;" class="d-flex j-center"
						  :action="$apiurl + 'seller/enterprise_publicity_manage_api.php'"
						  :data="{'act':'upload_photo_introduction','token':token,'user_id':user_id}"
						  :show-file-list="false"
						  :on-success="getLiveDylist"
						  accept='.jpg,.png.jpeg'>
						  <div style="cursor: pointer;width: 100%;flex-wrap: wrap;text-align: center;" class="d-flex j-center">
							<img style="width: 18px;height: 18px;margin-top: 8px;" src="../../assets/itemStore/tupian@2x.png" />
							<div style="font-size: 10px;color: #666666;width: 100%;text-align: center;margin-bottom: 8px;transform: scale(0.9);">图片</div>
						  </div>
						</el-upload>
						<div @click="setcenter()" style="cursor: pointer;width: 16.666%;flex-wrap: wrap;text-align: center;" class="d-flex j-center">
							<img style="width: 18px;height: 18px;margin-top: 8px;" src="../../assets/brand_fixtures/juzhong.png" />
							<div style="font-size: 10px;color: #666666;width: 100%;text-align: center;margin-bottom: 8px;transform: scale(0.9);">居中</div>
						</div>
						<div @click="upFiles()" style="cursor: pointer;width: 20%;flex-wrap: wrap;text-align: center;" class="d-flex j-center">
							<img style="width: 18px;height: 18px;margin-top: 8px;" src="../../assets/brand_fixtures/san.png" />
							<div style="font-size: 10px;color: #666666;width: 100%;text-align: center;margin-bottom: 8px;transform: scale(0.9);">上移</div>
						</div>
						<div @click="dowFiles()" style="cursor: pointer;width: 20%;flex-wrap: wrap;text-align: center;" class="d-flex j-center">
							<img style="width: 18px;height: 18px;margin-top: 8px;" src="../../assets/itemStore/xiayi@2x.png" />
							<div style="font-size: 10px;color: #666666;width: 100%;text-align: center;margin-bottom: 8px;transform: scale(0.9);">下移</div>
						</div>
						<div @click="delfiles()" style="cursor: pointer;width: 20%;flex-wrap: wrap;text-align: center;" class="d-flex j-center">
							<img style="width: 18px;height: 18px;margin-top: 8px;" src="../../assets/brand_fixtures/wu.png" />
							<div style="font-size: 10px;color: #666666;width: 100%;text-align: center;margin-bottom: 8px;transform: scale(0.9);">删除</div>
						</div>
					</div>
					<div class="txt-box d-flex" style="height: 612px;width: 100%;overflow-y: scroll;flex-wrap: wrap;">
						<div style="width: 100%;">
							<div style="padding: 3px 6px;font-size: 16px;font-weight: 700;color: #000000;text-align: center;
							box-sizing: border-box;padding: 0 30px;">
								{{wzTitle}}
							</div>
							<div v-if="wzTitle" style="font-size: 12px;padding: 3px 6px;color: #002451;display: flex;justify-content: center;">
								{{user_info.company_name}}<span style="color: #888888;margin-left: 6px;">{{curtime||getyymmdd()}}</span> 
							</div>
							<template v-for="(img,imgkey) in dyList">
								<img v-if="img.type == 2" style="width: 365px;box-sizing: border-box;display: block;"
								:style="imgkey === dyIndex?'border: 1px dashed #1E69FF;':''"
								@click="dyIndex = imgkey" :src="img.content" />
								<div @click="dyIndex = imgkey" :style="imgkey === dyIndex?'border: 1px dashed #1E69FF;':''"
								v-else style="padding: 3px 6px;font-size: 15px;color: #666;cursor: pointer;"
								:class="img.type == 3?'tct':'ntxt'">
									{{img.content}}
								</div>
							</template>
						</div>
					</div>
				</div>
				</div>
			  </div>
		  </template>
		  <span slot="footer" class="dialog-footer">
		    <el-button size="mini" @click="closeBox">取 消</el-button>
			<el-button v-if="!isSimple" size="mini" type="success" @click="save_draft()" >保存草稿</el-button>
		    <el-button size="mini" type="primary" @click="getwzContent()">确 定</el-button>
		  </span>
		</el-dialog>
		<el-dialog
		  title="提示"
		  :visible.sync="txtShow"
		  width="30%"
		  top="30vh">
		  <input v-model="txt" style="width: 100%;height: 30px;box-sizing: border-box;padding: 0 6px;" placeholder="请输入内容" />
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="txtShow=false" size="small" >取 消</el-button>
		    <el-button @click="setTxt()" size="small" type="primary" >确 定</el-button>
		  </span>
		</el-dialog>
	</div>
</template>

<script>
	import VueUeditorWrap from 'vue-ueditor-wrap'
	export default {
		components: {
			VueUeditorWrap,
		},
		data() {
			return {
				isSimple:false,
				txtShow:false,
				contents:'',
				jsconten:'',
				progress:0,
				myConfig: {
				  // 编辑器不自动被内容撑高
				  autoHeightEnabled: false,
				  // 初始容器高度
				  initialFrameHeight: 300,
				  // 初始容器宽度
				  initialFrameWidth: 780,
				  // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
				  // serverUrl: 'https://ueditor.szcloudplus.com/cos',
				  // serverUrl: 'https://www.spmall.com/ueditor/controller.php',
				  // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
				  UEDITOR_HOME_URL: '/UEditor/'
				},
				centerDialogVisible: false,
				ishowVideo:false,
				//广告图
				adBg:'',
				tempBg:'',
				tabState:true,
				videoTitle:'',
				videoBase64:'',
				ctShow:false,
				wzContents:'',
				cover:'',
				wzTitle:'',
				wzList:[],
				token: localStorage.getItem('token'),
				user_id: localStorage.getItem('user_id'),
				contenList:[],
				user_info:'',
				megData:'',
				ctid:'',
				dyList:[],
				imgindex:'',
				dyIndex:'',
				txt:'',
				closeTime:''
			};
		},
		created() {
			this.user_info = JSON.parse(localStorage.getItem('user_info'))
			this.get_enterprise_introduction_backdrop()
			this.business_intro()
			this.business_dynamic()
			this.get_enterprise_dynamic_list()
			this.leave_message_list()
		},
		methods: {
			closeBox(){
				this.ctShow = false
				clearInterval(this.closeTime)
			},
			//保存草稿
			save_draft(){
				localStorage.setItem('wzTitle',this.wzTitle)
				localStorage.setItem('cover',this.cover)
				localStorage.setItem('dyList',JSON.stringify(this.dyList))
				this.$message({
					showClose: false,
					message: '保存草稿成功',
					type: 'success',
					offset: 350
				})
			},
			setcenter(){
				if(this.dyList[this.dyIndex].type == 1){
					this.dyList[this.dyIndex].type = 3
				}else if(this.dyList[this.dyIndex].type == 3){
					this.dyList[this.dyIndex].type = 1
				}
			},
			setTxt(){
				this.dyList.push({type:1,content:this.txt})
				this.txt = ''
				this.txtShow = false
			},
			getLiveDylist(file, fileList) {
				this.dyList.push({type:2,content:file.data})
			  //   this.getBase64(file.raw).then((res) => {
					// this.dyList.push({type:2,content:res})
					// let params = {
					// 	act:'upload_photo_introduction',
					// 	token: localStorage.getItem('token'),
					// 	user_id: localStorage.getItem('user_id'),
					// 	file:res
					// }
					// this.$api.upload_photo_introduction(params).then((data)=>{
					// 	if(res.code == 0){
					// 		this.dyList.push({type:2,content:data.data})
					// 	}
					// })
			  //   })
			},
			//上移简介图片
			upFiles(){
				if(this.dyIndex === 0||this.dyIndex === ''){
					return
				}
				this.dyList.splice(this.dyIndex-1,0,this.dyList[this.dyIndex])
				this.dyList.splice(this.dyIndex+1,1)
				this.dyIndex--
			},
			//下移简介图片
			dowFiles(){
				if(this.dyIndex === (this.dyList.length-1) || this.dyIndex === ''){
					return
				}
				this.dyList.splice(this.dyIndex+2,0,this.dyList[this.dyIndex])
				this.dyList.splice(this.dyIndex,1)
				this.dyIndex++
			},
			//删除简介图片
			delfiles(){
				if(!this.dyList.length){
					return
				}
				this.dyList.splice(this.dyIndex,1)
				this.dyIndex = ''
			},
			format(percentage) {
				return percentage === 100 ? '上传完成' : `${percentage}%`;
			},
			onprogress(file){
				this.progress = parseInt(file.percent)
			},
			beforeUpload(file){
				const isLt2M = file.size / 1024 / 1024 < 100;
				if (!isLt2M) {
					this.$message({showClose: false,message: '上传大小不能超过 100MB!',type: 'error',offset: 350})
				}
				return isLt2M;
			},
			//获取留言列表
			leave_message_list(){
				
				let params = {
					act:'product_publish_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					size:20,
					page:1
				}
				this.$api.product_publish_list(params).then((res)=>{
					if(res.code == 0){
						this.megData = res.data
					}
				})
			},
			//删除留言
			leave_message_del(item){
				let params = {
					act:'product_publish_del',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					id:item.id
				}
				this.$api.product_publish_del(params).then((res)=>{
					if(res.code == 0){	
						this.$message({
							showClose: false,
							message: '删除成功',
							type: 'success',
							offset: 350
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
					this.leave_message_list()
				})
			},
			fileSuccess(res){
				this.videoBase64 = res.data
			},
			//设置tab状态
			setTabstate(state){
				this.tabState = state
			},
			//获取编辑器内容
			getContens() {
				this.centerDialogVisible = false
				if(this.tabState){
					// this.jsconten = this.contents
				}
			},
			openCtshow(){
				this.wzTitle = ''
				this.cover = ''
				this.wzContents = ''
				this.ctid = ''
				this.ctShow = true
				this.dyList = []
				if(localStorage.getItem('wzTitle')){
					this.wzTitle = localStorage.getItem('wzTitle')
				}
				if(localStorage.getItem('cover')){
					this.cover = localStorage.getItem('cover')
				}
				if(localStorage.getItem('dyList')){
					this.dyList = JSON.parse(localStorage.getItem('dyList'))
				}
				this.closeTime = setInterval(()=>{
					if(!this.isSimple){
						if(this.wzTitle){
							localStorage.setItem('wzTitle',this.wzTitle)
						}
						if(this.cover){
							localStorage.setItem('cover',this.cover)
						}
						if(this.dyList.length){
							localStorage.setItem('dyList',JSON.stringify(this.dyList))
						}
					}
				},180000)
			},
			openVideo(item){
				if(item.doc_type == 0){
					
					if(item.content_type == 1){
						this.ctid = item.id
						this.ctShow = true
						this.wzTitle = item.title
						this.cover = item.cover
						this.dyList = item.doc_content||[]
						this.isSimple = false
					}else{
						this.wzTitle = item.title
						this.cover = item.cover
						this.wzContents = item.doc_content
						this.ctid = item.id
						this.ctShow = true
						this.isSimple = true
					}
					
				}else{
					this.videoTitle = item.title
					this.videoBase64 = item.cover
					this.ishowVideo = true
				}
				
			},
			//提交视频信息
			enterprise_add_video(){
				if(this.videoTitle == ''){
					this.$message({showClose: false,message: '视频标题不能为空',type: 'error',offset: 350
					})
					return
				}
				if(this.videoBase64 == '请上传视频内容'){
					this.$message({showClose: false,message: '视频标题不能为空',type: 'error',offset: 350
					})
					return
				}
				let params = {
					act:'enterprise_add_video',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					file:[{type:1,content:this.videoTitle},
					{type:2,content:this.videoBase64}]
				}
				this.$api.enterprise_add_video(params).then((res)=>{
					if(res.code == 0){
						this.$message({showClose: false,message: '发布成功',type: 'success',offset: 350
						})
						this.videoTitle = ''
						this.videoBase64 = ''
						this.get_enterprise_dynamic_list()
						this.ishowVideo = false
					}else{
						this.$message({showClose: false,message: res.msg,type: 'error',offset: 350})
					}
				})
			},
			//显示编译器
			showContent() {
				this.show = !this.show;
			},
			//获取背景图base64
			getAdBg(file, fileList){
				this.getBase64(file.raw).then((res) => {
					this.adBg = res
				})
			},
			//获取封面
			getImg(file, fileList){
				this.getBase64(file.raw).then((res) => {
					this.cover = res
				})
			},
			//getVideo
			getVideo(file, fileList){
				this.getBase64(file.raw).then((res) => {
					this.videoBase64 = res
				})
			},
			//返回base64
			getBase64(file) {
			  return new Promise(function(resolve, reject) {
				const reader = new FileReader()
				let imgResult = ''
				reader.readAsDataURL(file)
				reader.onload = function() {
				  imgResult = reader.result
				}
				reader.onerror = function(error) {
				  reject(error)
				}
				reader.onloadend = function() {
				  resolve(imgResult)
				}
			  })
			},
			//预览
			previewJs(){
				if(this.contents){
					this.jsconten = this.contents
				}
				if(this.adBg){
					this.tempBg = this.adBg
				}
			},
			//发布文章
			getwzContent(){
				
				if(this.wzTitle == ''){
					this.$message({
						showClose: false,
						message: '标题不能为空',
						type: 'error',
						offset: 350
					})
					return
				}
				if(this.cover == ''){
					this.$message({
						showClose: false,
						message: '封面不能为空',
						type: 'error',
						offset: 350
					})
					return
				}
				if(this.wzContents == '' && this.isSimple){
					this.$message({
						showClose: false,
						message: '内容不能为空',
						type: 'error',
						offset: 350
					})
					return
				}
				let content = this.isSimple?this.wzContents:this.dyList
				let params = {
					act:this.ctid?'enterprise_edit_doc':'enterprise_add_doc2',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					title:this.wzTitle,
					content:content,
					cover:this.cover.indexOf('http')!==-1?'':this.cover,
					id:this.ctid,
					content_type:this.isSimple?0:1
				}
				
				this.$api.enterprise_add_doc2(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '操作成功',
							type: 'success',
							offset: 350
						})
						this.wzTitle = ''
						this.cover = ''
						this.wzContents = ''
						this.get_enterprise_dynamic_list()
						this.ctShow = false
						localStorage.removeItem('wzTitle')
						localStorage.removeItem('cover')
						localStorage.removeItem('dyList')
						clearInterval(this.closeTime)
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
			//获取文章列表
			get_enterprise_dynamic_list(){
				let params = {
					act:'get_enterprise_dynamic_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					size:99,
					business_id: localStorage.getItem('ru_id')
				}
				this.$api.wzlist(params).then((res)=>{
					this.wzList  = []
					if(res.code == 0){
						this.wzList = res.data
					}
				})
			},
			//删除文章
			del_enterprise_dynamic(item){
				let params = {
					act:'del_enterprise_dynamic',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					id:item.id
				}
				this.$api.del_enterprise_dynamic(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '删除成功',
							type: 'success',
							offset: 350
						})
						this.get_enterprise_dynamic_list()
					}else{
						this.$message({showClose: false,message: res.msg,type: 'error',offset: 350})
					}
				})
			},
			//发布企业介绍
			enterprise_introduction_release2(){
				
				let params = {
					act:'enterprise_introduction_release2',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					ei_img_base64:this.adBg,
					content:this.contents
				}
				
				this.$api.enterprise_introduction_release2(params).then((res)=>{
					console.log(res);
					if(res.code == 0){
						if(this.contents){
							this.jsconten = this.contents
						}
						if(this.adBg){
							this.tempBg = this.adBg
						}
						this.$message({
							showClose: false,
							message: '发布成功',
							type: 'success',
							offset: 350
						})
					}
				})
			},
			//获取企业介绍背景图
			get_enterprise_introduction_backdrop(){
				
				let params = {
					act:'get_enterprise_introduction_backdrop',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				
				this.$api.get_enterprise_introduction_backdrop(params).then((res)=>{
					if(res.code == 0){
						this.tempBg = res.data.img_url
					}
				})
			},
			//获取企业介绍
			business_intro(){
				let params = {
					act:'business_intro',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					business_id: localStorage.getItem('ru_id'),
				}
				this.$api.business_intro(params).then((res)=>{
					if(res.code == 0){
						if(typeof res.data.business_intro == 'object' || localStorage.getItem('store_type') == 0){
							let bus = res.data.business_intro
							if(localStorage.getItem('store_type') == 0){
								bus = JSON.parse(res.data.business_intro)
							}
							this.contenList = bus
							if(this.tempBg == ''){
								this.tempBg  = res.data.business_bg
							}
						}else{
							this.jsconten = res.data.business_intro
							this.contents = res.data.business_intro
						}
					}
				})
			},
			//获取企业动态
			business_dynamic(){
				let params = {
					act:'business_dynamic',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					business_id: localStorage.getItem('ru_id'),
				}
				// this.$api.business_dynamic(params)
			},
			getyymmdd(){
				let date = new Date();
				return date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date .getDate()+' '+date .getHours()+':'+date.getMinutes()
			}
		}
	};
</script>
<style>
	.el-dialog__wrapper{
		z-index: 999!important;
	}
	.v-modal{
		z-index: 998!important;
	}
	.img-box img{
		width: 100%!important;
	}
</style>
<style scoped>
	.tct{
		text-align: center;
		text-indent: 0px;
	}
	.ntxt{
		text-align: left;
		text-indent: 30px;
	}
	.txt-box::-webkit-scrollbar{
		  display: none;
	}
	.content-box{
		width: 1170px;
		min-height: 960px;
		background: #FFFFFF;
		border-radius: 6px;
		flex-wrap: wrap;
	}
	.left-box{
		box-sizing: border-box;
		width: 396px;
		height: 790px;
		border-radius: 14px;
		border: 10px solid #0C275E;
		position: relative;
	}
	.right-box{
		width: 375px;
		height: 790px;
		border: 2px solid #BBBBBB;
		border-radius: 6px;
		box-sizing: border-box;
		margin-left: 99px;
	}
	.button-box{
		margin-top: 300px;
		width: 60px;
		height: 90px;
		background: #F2F2F2;
		box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.2);
		border-radius: 0px 10px 10px 0px;
		border-left: none;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.img-box::-webkit-scrollbar{
		background: #f5f5f5;
		width: 5px;
	}
	.img-box::-webkit-scrollbar-thumb {
		/*滚动条里面的条*/
		border-radius: 10px;
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #CCCCCC;
		width: 5px;
	}
	.tabbar-box{
		height: 45px;
		background: #FFFFFF;
		box-shadow: 0px -10px 20px 0px rgba(209, 209, 209, 0.48);
		border-radius: 0px 0px 10px 10px;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		box-sizing: border-box;
		padding: 4px 28px;
	}
</style>
